import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { headerHeight } from "../../../NavBars/Header/hardCodeData";
import seal from "../../../Images/Main/seal_main.jpg";
import sealMob from "../../../Images/Main/seal_main_mob.jpg";
import { useTranslation } from "react-i18next";

interface props {
  id: number;
  name: string;
  Img: string;
  ImgMob: string;
}

const CarCard: FC<props> = ({ id, name, Img, ImgMob }) => {
  const { t } = useTranslation();

  return (
    <Box
      // className="car-section"
      sx={{
        height: `calc(100vh - 10vh - ${headerHeight})`,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        pt: "5vh",
        pb: "5vh",
        backgroundImage: { xs: `url(${ImgMob})`, md: `url(${Img})` },
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: { xs: "10vw", md: "46px" },
          color: "#fff",
          fontWeight: 600,
        }}
      >
        {name}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          // width: { xs: "70vw", md: "400px" },
          // height: { xs: "90px", md: "auto" },
        }}
      >
        <NavLink className="carCardMain" to={`/Explore?carId=${id}`}>
          {t("common:explore")}
        </NavLink>
        {/* <NavLink className="carCardMain" to={`/TestDrive?carId=${id}`}>
          {t("common:test_drive")}
        </NavLink> */}
      </Box>
    </Box>
  );
};

export default CarCard;
